import React from "react";

const LandingPage = () => {
  return (
    <div
      style={{
        height: "100vh",
        marginTop: "100px",
        backgroundImage: "url()",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ maxWidth: "1200px", padding: "0 16px" }}>
        <h1
          style={{
            color: "#fff",
            fontWeight: "bold",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
            textAlign: "center",
            fontSize: "3rem",
            margin: 0,
          }}
        >
          Welcome to Login
        </h1>
        <p
          style={{
            color: "#fff",
            marginTop: 16,
            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
            textAlign: "center",
            fontSize: "1.5rem",
            marginBottom: 0,
          }}
        >
          Please login to continue using our application
        </p>
      </div>
    </div>
  );
};

export default LandingPage;
